import type IOption from 'components/MappingModal/interfaces/IOption';

export const COUNTRY_CODES_FILTER_KEY = 'countryCodes';

export const ORG_STRUCTURE_FILTER_QUERY_KEY = 'profitCentres';

const COUNTRY_CODE_FILTER_KEYS = new Set([
  'countryCode',
  COUNTRY_CODES_FILTER_KEY,
  'countrycodes',
]);

const getValueChainNames = (
  valueChainIds?: number[],
  vcOptions?: IOption[],
): string => {
  if (!valueChainIds || valueChainIds.length === 0 || !vcOptions) {
    return '-';
  }

  const names = valueChainIds
    .filter((id) => id !== null)
    .map((id) => {
      const option = vcOptions.find((opt) => opt.value === id?.toString());
      return option?.name || option?.label;
    })
    .filter(Boolean);

  return names.length > 0 ? names.join(', ') : '-';
};

export default getValueChainNames;

export const pluralizeFilterType = (type: string): string => {
  if (type.endsWith('s')) {
    return type;
  }
  return `${type}s`;
};

export const isCountryCodeFilter = (filterType: string | undefined): boolean => (
  Boolean(filterType && COUNTRY_CODE_FILTER_KEYS.has(filterType))
);

export const getFilterIdentifier = (
  filter: { uniqueIdentifier?: string, name: string },
): string => filter.uniqueIdentifier || filter.name;

export const getFilterSelectionKey = (
  filter: { type: string, uniqueIdentifier?: string, name: string },
): string => encodeURIComponent(JSON.stringify({
  type: filter.type,
  uniqueIdentifier: getFilterIdentifier(filter),
}));

export const parseFilterSelectionKey = (
  selectionKey: string,
): { type: string, uniqueIdentifier: string } | null => {
  try {
    return JSON.parse(decodeURIComponent(selectionKey)) as { type: string, uniqueIdentifier: string };
  } catch {
    return null;
  }
};
